import React, { useEffect } from 'react';
import { CenterFrameLayout } from 'Layouts';
import { useStore } from 'Hooks/useStore';
import './SignUpPlansContainer.css';
import { redirectToFoxoneSubscribeFlow } from 'Utils/FoxoneSubs';

export const SignUpPlansContainer = () => {
  const { selectedPlan } = useStore('plans');

  useEffect(() => {
    redirectToFoxoneSubscribeFlow({ selectedPlan });
  }, [selectedPlan]);

  return (
    <CenterFrameLayout
      title="Checking your subscription"
      showLoader
      modernLayout
      customClass="signUpPlansContainer"
    ></CenterFrameLayout>
  );
};
